const doPermission = (el, binding, vnode,store)=>
{
    if (!store.state.user.authCode) {
      $(el).parent().append('&nbsp;')
      $(el).remove()
    } else {
      if (binding.value.indexOf(',') > 0) {
        let split = binding.value.split(',')
        let remove = true
        for (let i = 0; i < split.length; i++) {
          if (store.state.user.authCode.indexOf('|' + split[i] + '|') >= 0) {
            remove = false
          }
        }
        if (remove) {
          $(el).parent().append('&nbsp;')
          $(el).remove()

        }
      } else if (store.state.user.authCode.indexOf('|' + binding.value + '|') < 0) {
        $(el).parent().append('&nbsp;')
        $(el).remove()
      }
    }
}

export default {
  doPermission:doPermission
}
